export const agnieszkaFarbiszewska = {
    'mydrId': 'agnieszkafarbiszewska',
    'firstName': 'Agnieszka',
    'lastName': 'Farbiszewska',
    'profession': 'Psycholog, psychoterapeuta psychodynamiczny w trakcie szkolenia',
    'avatar': 'agnieszka-farbiszewska.webp',
    'slug': 'psycholog-agnieszka-farbiszewska',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'adult'],
        ['psychology', 'consultation']
    ]
}